






















import {Component, Emit, Model, Prop, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {DistrictStore} from "@/modules/regionsv2/district/store";
import { debounce } from "lodash";
import {DistrictParams} from "@/modules/regionsv2/district/params";
import DistrictLabelV2 from "@/modules/regionsv2/DistrictLabelV2/index.vue";
@Component({
    name: "DistrictSearchSelectorV2",
    components: {DistrictLabelV2}
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: String, default: "Gõ và lọc theo phường/Xã"}) readonly placeholder!: string;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';

    @Model("change", {type: Number})
    readonly districtId!: number;

    @Emit("change")
    handleChange(value?: number) {
        return value;
    }

    get districtIds() {
        return DistrictStore.ids;
    }

    onSearch(val) {
        const params = {
            ...new DistrictParams(),
            search: val
        }
        this.handleSearch(params);
    }

    handleSearch = debounce((params: any) => {
        DistrictStore.paramsChangeDistrictV21(params);
    }, 500)
}
